import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import ComparePlanSelectModal from './ComparePlanSelectModal';

const data = [
  {
    category: '경공매 검색',
    features: [
      {
        title: '종합검색',
        desc: '사건번호, 지역, 부동산 유형, 유찰횟수 등',
        '무료 체험': true,
        스탠다드: true,
        프리미엄: true,
      },
      {
        title: '지도검색',
        desc: '',
        '무료 체험': true,
        스탠다드: true,
        프리미엄: true,
      },
      {
        title: '특수조건 검색',
        desc: 'NPL, 대항력, 선순위임차인, HUG 인수조건 등',
        '무료 체험': true,
        스탠다드: true,
        프리미엄: true,
      },
      {
        title: '기타 검색',
        desc: '공매, 예정, 소재지, 법원, 일정 등',
        '무료 체험': true,
        스탠다드: true,
        프리미엄: true,
      },
    ],
    img: '/assets/images/payment/search.png',
  },
  {
    category: '경공매 물건정보',
    features: [
      {
        title: '경공매 기본정보',
        desc: '물건정보, 매각정보, 부동산 현황, 유찰횟수, 감정가 등',
        '무료 체험': true,
        스탠다드: true,
        프리미엄: true,
      },
      {
        title: '경공매 상세정보',
        desc: '등기부 현황, 권리분석 체크리스트, 경매집행비용',
        '무료 체험': '30건',
        스탠다드: '월 1,000건',
        프리미엄: '무제한',
      },
      {
        title: '가격분석',
        desc: '가격분석, 매각통계, 동일/인근 물건 실거래가 정보',
        '무료 체험': false,
        스탠다드: true,
        프리미엄: true,
      },
      {
        title: '예정물건 정보',
        desc: '',
        '무료 체험': false,
        스탠다드: true,
        프리미엄: true,
      },
    ],
    img: '/assets/images/payment/detail.png',
  },
  {
    category: 'AI 경공매 찾기',
    features: [
      {
        title: 'AI 탐색권',
        desc: '',
        '무료 체험': '30건',
        스탠다드: '월 500건',
        프리미엄: '무제한',
      },
    ],
    img: '/assets/images/payment/ai-search.png',
  },
  {
    category: '12가지 테마 퀀트 분석',
    features: [
      {
        title: 'VIP 퀀트 분석 리포트',
        desc: '예상 낙찰가, 보유기간, 세후이익 분석',
        '무료 체험': '10건',
        스탠다드: '월 100건',
        프리미엄: '무제한',
      },
    ],
    img: '/assets/images/payment/quant.png',
  },
  {
    category: 'AI 경매 알고리즘',
    features: [
      {
        title: 'AI 경매 알고리즘 만들기',
        desc: '나만의 투자전략 생성',
        '무료 체험': '10건',
        스탠다드: '월 100건',
        프리미엄: '무제한',
      },
      {
        title: 'AI 경매 알고리즘 수익분석',
        desc: '나만의 투자전략 안전성, 시세차익 가능성, 수익성 분석',
        '무료 체험': '10건',
        스탠다드: '월 100건',
        프리미엄: '무제한',
      },
      {
        title: 'AI 경매 알고리즘 추천물건',
        desc: '알고리즘 적용한 물건검색',
        '무료 체험': '10건',
        스탠다드: '무제한',
        프리미엄: '무제한',
      },
    ],
    img: '/assets/images/payment/algo.png',
  },
  {
    category: '등기부/전입세대열람원',
    features: [
      {
        title: '등기부등본 열람',
        desc: '',
        '무료 체험': '30건',
        스탠다드: '월 1,000건',
        프리미엄: '무제한',
      },
      {
        title: '전입세대열람원 열람',
        desc: '아파트만 열람가능',
        '무료 체험': '30건',
        스탠다드: '월 1,000건',
        프리미엄: '무제한',
      },
    ],
    img: '/assets/images/payment/register.png',
  },
  {
    category: '경매 통계',
    features: [
      {
        title: '주간/월간 경매 통계',
        '무료 체험': '샘플만 가능',
        스탠다드: '월간 통계만 가능',
        프리미엄: true,
      },
      {
        title: '나만의 통계',
        desc: '주소지, 사건번호 기반\n경매/공매/부동산 통계',
        '무료 체험': '샘플만 가능',
        스탠다드: '샘플만 가능',
        프리미엄: true,
      },
      {
        title: 'NPL 통계',
        '무료 체험': '샘플만 가능',
        스탠다드: '샘플만 가능',
        프리미엄: true,
      },
    ],
    img: '/assets/images/payment/statistics.png',
  },
  {
    category: 'NPL(부실채권)',
    features: [
      {
        title: '부실채권(NPL) 투자수익분석',
        desc: '부실채권 예상 비용 및 수익분석',
        '무료 체험': '10건',
        스탠다드: '월 1,000건',
        프리미엄: '무제한',
      },
      {
        title: 'NPLatform (부실채권 분석)',
        desc: '',
        '무료 체험': false,
        스탠다드: false,
        프리미엄: '월 100건',
      },
    ],
    img: '/assets/images/payment/npl.png',
  },
  {
    category: '플러스 분석',
    features: [
      {
        title: '빌딩, 농지 심화분석',
        desc: '',
        '무료 체험': '10건',
        스탠다드: '월 1,000건',
        프리미엄: '무제한',
      },
    ],
    img: '/assets/images/payment/plus.png',
  },
  {
    category: '프리미엄 혜택',
    features: [
      {
        title: '월간 땅집고옥션 추천상품',
        desc: '',
        '무료 체험': false,
        스탠다드: false,
        프리미엄: true,
      },
      // {
      //   title: '사용자 맞춤형 부동산 물건 분석',
      //   desc: '',
      //   '무료 체험': false,
      //   "스탠다드": false,
      //   "프리미엄": true,
      // },
      {
        title: '전문가 상담 서비스',
        desc: '',
        '무료 체험': false,
        스탠다드: false,
        프리미엄: '월 1회 / 30분',
      },
    ],
    img: '/assets/images/payment/Premium.png',
  },
];

type Membership = '무료 체험' | '스탠다드' | '프리미엄';

function ComparePlan() {
  const [openPlanSelectModal, setOpenPlanSelectModal] = useState(false);
  const [changeInput, setChangeInput] = useState(1);
  const [compareMembership1, setCompareMembership1] =
    useState<Membership>('무료 체험');
  const [compareMembership2, setCompareMembership2] =
    useState<Membership>('스탠다드');

  const [currentTab, setCurrentTab] = useState('경공매 검색');
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);
  const tabScrollRef = useRef<HTMLDivElement>(null);

  const scrollTabIntoCenter = () => {
    const index = data.findIndex((item) => item.category === currentTab);
    const tabEl = tabRefs.current[index];
    const scrollContainer = tabScrollRef.current;

    if (tabEl && scrollContainer) {
      const scrollOffset =
        tabEl.offsetLeft -
        scrollContainer.clientWidth / 2 +
        tabEl.clientWidth / 2;

      scrollContainer.scrollTo({ left: scrollOffset, behavior: 'smooth' });
    }
  };

  const tabItems = useMemo(() => data.map(({ category }) => category), []);

  const section = useMemo(
    () => data.find((d) => d.category === currentTab),
    [currentTab],
  );

  const renderTd = (data: string | boolean) => {
    if (typeof data === 'string') {
      return data;
    }
    if (data === true) {
      return <img src="/assets/images/check/check-purple.svg" alt="" />;
    }
    return <img src="/assets/images/icon/minus.svg" alt="" />;
  };

  useEffect(() => {
    scrollTabIntoCenter();
  }, [currentTab]);

  return (
    <Container id="compare">
      <Title>요금제 비교</Title>
      <Header>
        <SelectContainer>
          <SelectButton
            onClick={() => {
              setChangeInput(1);
              setOpenPlanSelectModal(true);
            }}
          >
            <SelectButtonContent>{compareMembership1}</SelectButtonContent>
            <img src="/assets/images/arrow/arrow_down.svg" alt="" />
          </SelectButton>
          <SelectButton
            onClick={() => {
              setChangeInput(2);
              setOpenPlanSelectModal(true);
            }}
          >
            <SelectButtonContent>{compareMembership2}</SelectButtonContent>
            <img src="/assets/images/arrow/arrow_down.svg" alt="" />
          </SelectButton>
        </SelectContainer>
        <TabBox ref={tabScrollRef}>
          <TabInner>
            {tabItems.map((tab, index) => (
              <Tab
                key={index}
                ref={(el) => {
                  tabRefs.current[index] = el;
                }}
                $active={currentTab === tab}
                onClick={() => setCurrentTab(tab)}
              >
                {tab}
              </Tab>
            ))}
          </TabInner>
        </TabBox>
      </Header>
      {/* {fixed && <HeaderSpacer style={{ height: headerH }} />} */}
      <Content>
        <SectionImg src={section?.img} alt="img" />

        {section && (
          <Table>
            <TableTitle>{section?.category}</TableTitle>
            {section.features.map((item) => (
              <TableRow key={item.title}>
                <TableItem>
                  <ItemContent>
                    {item.title}
                    <ItemDesc>{item.desc}</ItemDesc>
                  </ItemContent>
                  {renderTd(item[compareMembership1])}
                </TableItem>
                <TableItem>
                  <ItemContent>
                    {item.title}
                    <ItemDesc>{item.desc}</ItemDesc>
                  </ItemContent>
                  {renderTd(item[compareMembership2])}
                </TableItem>
              </TableRow>
            ))}
          </Table>
        )}
      </Content>

      {openPlanSelectModal && (
        <ComparePlanSelectModal
          select={changeInput === 1 ? compareMembership1 : compareMembership2}
          other={changeInput === 1 ? compareMembership2 : compareMembership1}
          changeSelect={
            changeInput === 1 ? setCompareMembership1 : setCompareMembership2
          }
          onClose={() => setOpenPlanSelectModal(false)}
        />
      )}
    </Container>
  );
}

export default ComparePlan;

const Container = styled.div`
  display: flex;
  padding: 40px 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  position: relative;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  color: #222;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.4px;
`;

const Header = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: #fff;
  border-bottom: 1px solid #e1e2e4;
  position: sticky;
  top: 56px;
  z-index: 10;
`;

const HeaderSpacer = styled.div`
  width: 100%;
  flex: 0 0 auto;
`;

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const SelectButton = styled.div`
  display: flex;
  padding: 10px 12px;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  border-radius: 8px;
  background: #f7f8fc;
`;

const SelectButtonContent = styled.div`
  flex: 1 0 0;
  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const Content = styled.div`
  display: flex;
  padding: 0 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const TabBox = styled.div`
  width: 100%;
  max-width: inherit;
  background-color: #fff;
  overflow-x: auto;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

const TabInner = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &::after {
    content: '';
    flex: 0 0 10px;
  }
`;

const Tab = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  border-radius: 20px;

  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;

  color: ${({ $active }) => ($active ? '#ffffff' : '#989BA2')};
  background-color: ${({ $active }) => ($active ? '#222222' : '#FFFFFF')};
  border: 1px solid;
  border-color: ${({ $active }) => ($active ? 'transparent' : ' #E5E8EA')};
  white-space: nowrap;
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const TableTitle = styled.div`
  display: flex;
  padding: 8px 0;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const TableRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-top: 1px solid #e1e2e4;
`;

const TableItem = styled.div`
  display: flex;
  padding: 16px 16px 24px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  color: #222;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: #222;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const ItemDesc = styled.div`
  color: #616161;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
  white-space: pre-line;
`;

const SectionImg = styled.img`
  width: 100%;
  height: auto;
  align-self: stretch;
  border-radius: 16px;
`;
